import { render, staticRenderFns } from "./Naw2.vue?vue&type=template&id=c3761626&scoped=true&"
import script from "./Naw2.vue?vue&type=script&lang=js&"
export * from "./Naw2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3761626",
  null
  
)

export default component.exports